import { MESSAGE_TYPE_QUARANTINE } from "@/constants";

export default function (name) {
  return MESSAGE_TYPE_QUARANTINE[name] || "Clean";
}
